export default __webpack_public_path__ + "static/media/team-5.d59ab7b9.jpg";